import React from 'react';
import {Button, Col,ControlLabel, FormGroup, Modal} from 'react-bootstrap';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import './styles.css'
const ReactTags = require('react-tag-autocomplete');

class ImportModal extends React.Component{
    static contextTypes = { api:PropTypes.object, notifier: PropTypes.object };
    constructor(props,context){
        super(props);
        this.state = {
            mailerTags:[],
            fileToImport:[],
        };
        context.api.mailerTags.get( 0, 200, '@Class.MailerTags.mailerTags.get' )
    }

    onFileSelect = (e)=>{
        const files = e.target.files;
        if( !files || !files.length ) return;
        this.setState({fileToImport:files[0]});
    };

    importFile = () =>{
        if(this.state.fileToImport.length<1) return this.context.notifier.error('No se seleccionó un archivo para importar');
        this.setState({loading:true});
        if(this.state.mailerTags) {
            const tags = [...this.state.mailerTags];
            let tagsToSave = [];
            for (let i=0;i<tags.length;i++){
                if(this.props.mailerTags.indexOf(tags[i])===-1) tagsToSave.push({"name":tags[i].name});
                else tagsToSave.push(this.props.mailerTags[this.props.mailerTags.indexOf(tags[i])].id)
            }
            this.context.api.emailAddresses.import( tagsToSave, this.loadingId, this.state.fileToImport)
            .then (( res ) => {
                if(res) {
                    this.setState({resultado:{
                            importados:res.emailAddresses.length,
                            errorsNr:res.errors.length,
                            errorsText:res.errors
                        },loading:false, imported:true})
                }
            })
        }
    };

    handleDeleteTag = (i) => {
        const mailerTags  = this.state.mailerTags.slice(0);
        mailerTags.splice(i,1);
        this.setState({...this.state,mailerTags: mailerTags});
    };

    handleAdditionTag = (tag) => {
        const tags = [...this.state.mailerTags];
        let tagExists = false;
        for(let i=0; i<tags.length;i++){
            if(tag.id===undefined) { if(tags[i].name===tag.name) return tagExists }
            else{if( tags[i].id===tag.id) return tagExists=true; }
        }
        if(tags<1 || tagExists===false) tags.push(tag);
        return this.setState({mailerTags:tags})
    };

    render(){
        const {onHide} = this.props
        return (
            <Modal
                show={true}
                onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Importar archivo de contactos</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="container-fluid ImportModal">
                        <div className="row">
                            <div className="col-md-12">
                                {!this.state.imported?
                                    <div>
                                        <FormGroup controlId="formHorizontalEmail">
                                            <Col componentClass={ControlLabel} sm={2} className='tagsLabel'>Tags:</Col>
                                            <Col sm={10}>
                                                <ReactTags
                                                    tags={this.state.mailerTags}
                                                    allowNew={true}
                                                    placeholder=''
                                                    suggestions={this.props.mailerTags}
                                                    handleDelete={this.handleDeleteTag}
                                                    handleAddition={this.handleAdditionTag}
                                                    autofocus={false}/>
                                            </Col><br/><br/><br/>
                                        </FormGroup>
                                        <div className='contentImport'><a href="/formato_de_importacion_de_correos.xlsx" download >Archivo muestra</a><br/><br/><br/></div>
                                        <FormGroup>
                                            <Col componentClass={ControlLabel} sm={12}>
                                                <input type='file'  className='contentImport'
                                                       onChange={(e)=>this.onFileSelect(e)}/></Col>
                                        </FormGroup><br/><hr/>
                                    </div>
                                :null}
                                {this.state.loading?
                                    <FormGroup>
                                        <Col componentClass={ControlLabel} sm={12} className='resultMessage'>
                                            <i className="spinning fa fa-spinner" aria-hidden="true"/> Cargando...
                                        </Col>
                                    </FormGroup>
                                :null}
                                {this.state.resultado?
                                    <FormGroup>
                                        <Col componentClass={ControlLabel} sm={12} className='resultMessage'>
                                            <span>Se {this.state.resultado.importados===1?
                                                <span>importó {this.state.resultado.importados} contacto.<br/></span>
                                                :<span>importaron {this.state.resultado.importados} contactos.<br/></span>}</span>
                                            <span>Se {this.state.resultado.errorsNr===1?
                                                <span>encontró {this.state.resultado.errorsNr} error.<br/></span>
                                                :<span>encontraron {this.state.resultado.errorsNr} errores{this.state.resultado.errorsNr>0?<span>:<br/></span>:<span>.</span>}</span>}</span>
                                            {this.state.resultado.errorsText.length>0?
                                                this.state.resultado.errorsText.map((e,key)=>{return <span key={key}>- {e}<br/></span>}):null}<hr/>
                                        </Col>
                                    </FormGroup>:null}<br/><br/>

                                    <Button
                                        bsStyle='danger'
                                        onClick={this.props.onHide}>Cerrar</Button>
                                <Button
                                    onClick={this.importFile}
                                    bsStyle='success'
                                    disabled={this.state.imported}
                                    className='pull-right'>Importar</Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}
const mapStateToProps = ( { api:{mailerTags=[]}, loadingIds } )=>({mailerTags, loadingIds});

export default connect(mapStateToProps)(ImportModal);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/components/ImportModal/index.jsx